import { t } from "i18next";
import { FC, useEffect, useState } from "react";
import { Product } from "interface/common";
import CustomButton, { TextButton } from "ui/Button";
import { handleFilteredItem } from "utils/statUtils";
import GridWithGroupPaging from "ui/grid/GridWithGroupPaging";
import { ICON_NAMES } from "utils/constant";

const ROW_HEIGHT = 36;
const HEADER_HEIGHT = 40;
const MIN_HEIGHT = 80;

interface IPage {
	skip: number;
	take: number;
	text: string; // Added text property
}
export const ProductGrid: FC<{
	data: Product[];
	page?: IPage;
	setPage?: (page: IPage) => void;
	headerText: string;
	btnIconName: string;
	btnClick: (product: Product) => void;
	showAllProducts?: boolean;
	hideVirtualScroll?: boolean;
	isMobileView?: boolean;
}> = ({
	data,
	page = {
		skip: 0,
		take: 20,
		totalCount: 0,
		isSearched: false,
	},
	setPage,
	btnIconName,
	btnClick,
	headerText,
	showAllProducts = true,
	hideVirtualScroll = false,
	isMobileView = false,
}) => {
	const [gridData, setGridData] = useState<Product[]>(data);

	useEffect(() => {
		setGridData(data);
	}, [data]);

	const gridHeight = Math.max(
		gridData.length * ROW_HEIGHT + HEADER_HEIGHT,
		MIN_HEIGHT,
	);

	const getData = async (searchText: string = "", take: number) => {
		if (!setPage) return;
		try {
			const newPage: IPage = {
				skip: 0,
				take: take,
				text: searchText,
			};
			setPage(newPage);
		} catch (error) {
			console.error("Error searching products:", error);
		}
	};
	const ButtonCell = (props: any) => {
		return (
			<td style={{ textAlign: "center" }}>
				<TextButton
					text={""}
					bgStyle={{
						height: "26px",
					}}
					iconName={btnIconName}
					onClick={() => btnClick(props.dataItem)}
				/>
			</td>
		);
	};

	return (
		<div>
			<div
				style={{ textAlign: "center", marginBottom: "20px" }}
			>
				{headerText}
			</div>
			{isMobileView ? (
				<div className="user-profile-setting-mobile-list">
					{gridData.length === 0 && (
						<div className="user-profile-setting-mobile-empty">{t("NoRows")}</div>
					)}
					{gridData.map((product) => (
						<div key={product.id} className="user-profile-setting-mobile-card">
							<div className="user-profile-setting-mobile-card-header user-profile-setting-mobile-card-header--simple">
								<div className="user-profile-setting-mobile-card-title">
									{product.name}
								</div>
							</div>
							{/* <div className="user-profile-setting-mobile-card-body">
								<div>
									<span>{t("Preservation")}</span>
									<strong>{product.preservationType || "-"}</strong>
								</div>
								<div>
									<span>{t("Condition")}</span>
									<strong>{product.condition || "-"}</strong>
								</div>
								<div>
									<span>{t("Size")}</span>
									<strong>{product.size || "-"}</strong>
								</div>
								<div>
									<span>{t("Quality")}</span>
									<strong>{product.quality || "-"}</strong>
								</div>
							</div> */}
							<div className="user-profile-setting-mobile-card-actions">
								<CustomButton
									label={t("Delete")}
									iconName={btnIconName}
									onClick={() => btnClick(product)}
									btnStyle={{ width: "100%", minHeight: "44px" }}
								/>
							</div>
						</div>
					))}
				</div>
			) : (
				<GridWithGroupPaging
					gridData={gridData}
					className={hideVirtualScroll ? "hide-virtual-scroll" : ""}
					filterable={showAllProducts}
					pageable={showAllProducts}
					serverFilter={true}
					gridHeight={gridHeight}
					itemAboveHeight={170}
					handleStateChange={(state) => {
						if (state.filter) {
							const filters = handleFilteredItem(state.filter);
							const text = filters[0].values[0];
							getData(text, state.take || 20);
						} else {
							getData("", state.take || 20);
						}
					}}
					filterOperators={{
						text: [{ text: "grid.filterContainsOperator", operator: "contains" }],
					}}
					gridColumns={[
						{
							field: "name",
							title: t("Description"),
							filter: "text",
							filterable: showAllProducts,
						},
						{
							cells: {
								data: ButtonCell,
							},
							title: "",
							width: "100px",
							filterable: false,
						},
					]}
				/>
			)}
		</div>
	);
};
